import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-survey-sms",
  templateUrl: "./survey-sms.component.html",
  styleUrls: ["./survey-sms.component.scss"],
})
export class SurveySmsComponent implements OnInit {
  public static hideLatestSurveyHref = true;

  lp: string;
  earningId: string;
  show = false;
  smsNavState: any;

  constructor(private route: ActivatedRoute) {
    this.lp = this.route.snapshot.paramMap.get("lp");
    this.earningId = this.route.snapshot.paramMap.get("earningId");
  }

  ngOnInit(): void {
    if (this.lp && this.earningId) {
      const isPeynirciSerdivan = this.lp === "peynirci-serdivan";
      this.smsNavState = {
        landingPageKey: this.lp.replace("-serdivan", ""),
        earningId: this.earningId,
        isPeynirciSerdivan,
      };
      this.show = true;
    }
  }
}
